import React from "react";
import {
  ButtonDropdown,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";
import { components } from "react-select";
import Select from "react-select";
import {
  FilterMultiSelectDataType,
  FilterOffsetType,
  FilterTextType,
} from "./AllClientBulkUpload";
import { CircularAvatar, DropDown, RadioContainer } from "../../../commons";
import {
  CloseIcon,
  filterBlackIcon,
  FilterIcon,
} from "../../../../assets/images";
import { UPLOAD_TYPE_FILTER } from "../../../../constant/tableHeadersConstants/allBulkUploadReportConst";
import { RadioTypes } from "../../../../commonTypes/universalTypes";

const RADIO_OPTIONS: RadioTypes[] = [
  {
    id: "1",
    _id: "1",
    name: "Ready",
  },
  {
    id: "0",
    _id: "0",
    name: "Processing",
  },
];
type DropDownOptionType = {
  value: number | null | undefined;
  label: string;
};


type AppProps = {
  toggle: boolean;
  setToggle: (data: boolean) => void;
  setFilterText: React.Dispatch<React.SetStateAction<FilterTextType>>;
  finalUserList: DropDownOptionType[];
  filterValue: any;
  setFilterValue: React.Dispatch<
    React.SetStateAction<FilterMultiSelectDataType>
  >;
  multiSelectData: FilterMultiSelectDataType;
  handleApplyFilter: () => void;
  handleFilterClear: () => void;
  setFilterOffset: React.Dispatch<React.SetStateAction<FilterOffsetType>>;
  setUserOffset: React.Dispatch<React.SetStateAction<number>>;
  limit: number;
  finalClientList: DropDownOptionType[];
};

const AllClientBulkUploadFilter = ({
  toggle,
  setToggle,
  finalUserList,
  handleApplyFilter,
  handleFilterClear,
  multiSelectData,
  filterValue,
  setFilterValue,
  setFilterOffset,
  setFilterText,
  limit,
  finalClientList,
}: AppProps) => {
  const filterCount: number = Object.values(multiSelectData).filter((e: any) =>
    e?.hasOwnProperty("value")
      ? e?.value?.toString()?.length > 0
      : e?.toString()?.length > 0
  ).length;

  const Option = (props: any) => {
    const { data } = props;
    return (
      <components.Option {...props}>
        <div
          className="d-flex justify-content-sm-start"
          style={{ gap: "10px" }}
        >
          {data?.label !== "Select" ? (
            <CircularAvatar
              name={data?.label}
              image={data?.image && data?.image}
            />
          ) : (
            <></>
          )}
          {data?.label}
        </div>
      </components.Option>
    );
  };
  const clearFilter = () => {
    resetFilter();
    handleFilterClear();
  };

  const checkUserBottom = (e: any) => {
    setFilterOffset((prv: FilterOffsetType) => ({
      ...prv,
      userOffset: prv?.userOffset + limit,
    }));
  };

  const checkClientBottom = (e: any) => {
    setFilterOffset((prv: FilterOffsetType) => ({
      ...prv,
      clientOffset: prv?.clientOffset + limit,
    }));
  };

  const empty = () => {
    const { client, user, type, status }: any = multiSelectData;

    setFilterValue({ client, user, type, status });
  };

  const resetFilter = () => {
    setFilterValue({
      client: { label: "", value: null },
      user: { label: "", value: null },
      type: { label: "", value: null },
      status: "",
    });
  };

  const dropDownStyle = {
    option: (baseStyles: any, state: any) => ({
      ...baseStyles,
      width: "100%",
    }),
    control: (provided: any, state: any) => ({
      ...provided,
      width: "65%",
    }),
    container: (provided: any) => ({
      ...provided,
      width: "150%",
      // position: 'absolute'
    }),
  };

  return (
    <ButtonDropdown
      isOpen={toggle}
      toggle={() => {
        filterCount === 0 && toggle ? resetFilter() : empty();
        setToggle(!toggle);
      }}
    >
      <DropdownToggle
        caret
        color="#262a44"
        style={{
          border: "1px solid #bfcbe1",
          backgroundColor: "#ffffff",
          height: "38px",
        }}
      >
        <img src={filterCount !== 0 ? FilterIcon : filterBlackIcon} alt="" />
        <span className={filterCount !== 0 ? "filter-count" : ""}>
          <span>{filterCount !== 0 ? filterCount : ""}</span>
        </span>
      </DropdownToggle>
      <DropdownMenu right style={{ width: "400px", padding: "15px 25px 30px" }}>
        <div className="d-flex justify-content-between mt-0 mb-0">
          <h5 className="text-center ">Filter</h5>
          <div
            className="pointer"
            onClick={() => {
              setToggle(!toggle);
            }}
          >
            <img src={CloseIcon} alt="" />
          </div>
        </div>
        <hr className="mt-0 mb-2" />

        <div className="row d-flex mt-3 mb-3">
          <div className="col-md-6">
            <label className="mb-1" style={{ fontSize: "14px" }}>
              Select User
            </label>
            <Select
              options={[{ value: null, label: "Select" }, ...finalUserList]}
              value={filterValue?.user?.value ? filterValue?.user : "Select"}
              components={{ Option }}
              cacheOptions
              onChange={(e) =>
                setFilterValue((prev: any) => ({ ...prev, user: e }))
              }
              onMenuScrollToBottom={(e: any) => checkUserBottom(e)}
              onInputChange={(e: string) => {
                setFilterText((prev: any) => ({ ...prev, userText: e }));
                setFilterOffset((prev: any) => ({ ...prev, userOffset: 0 }));
              }}
              onMenuClose={() =>
                setFilterOffset((prev: any) => ({ ...prev, user: 0 }))
              }
              placeholder="Select"
              styles={dropDownStyle}
            />
          </div>
          <div className="col-md-6">
            <label className="mb-1" style={{ fontSize: "14px" }}>
              Select Client
            </label>
            <Select
              options={[{ value: null, label: "Select" }, ...finalClientList]}
              value={
                filterValue?.client?.value ? filterValue?.client : "Select"
              }
              cacheOptions
              onChange={(e) =>
                setFilterValue((prev: any) => ({ ...prev, client: e }))
              }
              onMenuScrollToBottom={(e: any) => checkClientBottom(e)}

              onInputChange={(e: string) => {
                setFilterText((prev: any) => ({ ...prev, clientText: e }));
                setFilterOffset((prev: any) => ({ ...prev, clientOffset: 0 }));
              }}
              placeholder="Select"
              onMenuClose={() =>
                setFilterOffset((prev: any) => ({ ...prev, client: 0 }))
              }
              styles={dropDownStyle}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <label className="mb-1" style={{ fontSize: "14px" }}>
              Upload Type
            </label>
            <div className="mt-1">
              <DropDown
                options={UPLOAD_TYPE_FILTER}
                value={filterValue?.type?.value ? filterValue?.type : "Select"}
                handleChange={(e) =>
                  setFilterValue((prev: any) => ({ ...prev, type: e }))
                }
              />
            </div>
          </div>
        </div>
        <div className="row d-block p-3">
          <div>
            <label style={{ fontSize: "14px" }}>Status</label>
          </div>
          <div className="mt-2">
            <RadioContainer
              optionsList={RADIO_OPTIONS}
              handleSetRadioValue={(e) =>
                setFilterValue((prev: any) => ({ ...prev, status: e }))
              }
              radioValue={filterValue?.status}
            />
          </div>
        </div>
        <div className="d-flex align-items-center justify-content-end mt-3">
          <button
            className="mr-2 btn btn-outline"
            onClick={() => {
              clearFilter();
              setToggle(!toggle);
            }}
          >
            Clear Filter
          </button>
          <button
            className="pl-4 pr-4 btn btn-primary"
            onClick={() => {
              handleApplyFilter();
              setToggle(!toggle);
            }}
          >
            Apply
          </button>
        </div>
      </DropdownMenu>
    </ButtonDropdown>
  );
};

export default AllClientBulkUploadFilter;
